module.exports = __webpack_public_path__ + "static/feature-4-065d9f6050c8df141194dcd44945c5e1.svg";